import { useCallback } from 'react';

import { useShoppingCart } from '../hooks/shoppingCart';

export const useIsProductInCart = () => {
  const { data } = useShoppingCart();

  const isProductInCart = useCallback(
    (sku: string) => {
      if (!data || !data?.items) return false;
      return data?.items?.some((item) => item.sku === sku);
    },
    [data]
  );

  return { isProductInCart };
};
